import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M17.3535 3.64655C15.5179 1.81314 12.9165 0.755832 10.0561 1.04828C5.92313 1.46445 2.52216 4.81634 2.06043 8.94434C1.44105 14.3996 5.66412 19 10.9908 19C14.5832 19 17.6689 16.8966 19.1103 13.8709C19.4707 13.1173 18.9302 12.2512 18.0968 12.2512C17.6801 12.2512 17.286 12.4762 17.1058 12.8474C15.8332 15.5806 12.7814 17.3128 9.44796 16.5704C6.94793 16.0193 4.93212 13.9834 4.40283 11.4864C3.45686 7.12217 6.77901 3.25288 10.9908 3.25288C12.8602 3.25288 14.5269 4.02898 15.7431 5.25501L14.0427 6.95345C13.3332 7.66207 13.8287 8.87685 14.831 8.87685H18.8738C19.4932 8.87685 20 8.37069 20 7.75205V3.71404C20 2.71297 18.7838 2.20682 18.0743 2.91544L17.3535 3.64655Z",
            fill: "black"
        })
    }));
};
export default Icon;
